<template>
  <div class="news">
    <h2>{{ getWho() }}的捐赠动态</h2>
    <transition-group tag="ul" name="fade">
      <li v-for="(item, index) in donationObjects" :key="index">
        <div class="image">
          <webp-image :src="item.icon" width="100%" />
          <div class="date">{{ formatDate(item.date) }}</div>
        </div>
        <p class="title">{{ getWho() }}为{{ item.name }}捐赠了 {{ duration2course(item.duration) }} 节智能课程</p>
      </li>
    </transition-group>
  </div>
</template>

<script>
  import WebpImage from '@/components/common/WebpImage'

  export default {
    name: 'news',
    props: {
      shared: {
        type: Boolean,
        default: false
      },
      donationObjects: {
        type: Array,
        default: []
      }
    },
    computed: {
      basicDonateDuration () {
        return this.$store.state.BASIC_DONATE_DURATION
      }
    },
    methods: {
      formatDate (date) {
        return date.replace(/-/g, ' · ')
      },
      duration2course (duration) {
        return Math.floor(duration / this.basicDonateDuration)
      },
      getWho () {
        return this.shared ? 'Ta' : '我'
      }
    },
    components: {
      WebpImage
    }
  }
</script>

<style lang="scss" scoped>
  @import "../assets/scss/vars";

  .news {
    padding-top: 80px;
    padding-left: 60px;
    padding-right: 60px;
    padding-bottom: 80px;
    h2 {
      font-size: 48px;
      font-weight: normal;
      line-height: 60px;
    }
    li {
      margin-top: 60px;
      .image {
        position: relative;
        width: 100%;
        font-size: 0;
        .date {
          position: absolute;
          left: 20px;
          bottom: 20px;
          z-index: 2;
          height: 46px;
          padding-left: 20px;
          padding-right: 20px;
          font-size: 26px;
          color: $white;
          line-height: 46px;
          background-color: $black;
          border-radius: 23px;
        }
      }
      .title {
        margin-top: 30px;
        font-size: 30px;
        color: rgba($black, 0.87);
        line-height: 42px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// News.vue?03340ef6